import { render, staticRenderFns } from "./Specialist.vue?vue&type=template&id=1553aaee&scoped=true"
import script from "./Specialist.vue?vue&type=script&lang=js"
export * from "./Specialist.vue?vue&type=script&lang=js"
import style0 from "./Specialist.vue?vue&type=style&index=0&id=1553aaee&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1553aaee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1553aaee')) {
      api.createRecord('1553aaee', component.options)
    } else {
      api.reload('1553aaee', component.options)
    }
    module.hot.accept("./Specialist.vue?vue&type=template&id=1553aaee&scoped=true", function () {
      api.rerender('1553aaee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialists/management/components/specialist-tab/Specialist.vue"
export default component.exports